import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Rename function to start with uppercase (Login)
export default function Login() {
  const navigate = useNavigate()
  const [data, setdata] = useState({ email: "", password: "" });
  const onchange = (e) => {
    setdata({ ...data, [e.target.name]: e.target.value });
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`https://fullstack-backend-mtio.onrender.com/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email: data.email, password: data.password }),
    });
    const json = await response.json();
    if (json.success){
      localStorage.setItem("token",json.authtoken)
      navigate("/")
    }
    else{
      alert("wrong")
    }
    console.log(json);
  };
  return (
    <div className="container">
      <form className="container" onSubmit={handlesubmit}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email address
          </label>
          <input
            type="email"
            name="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            value={data.email}
            onChange={onchange}
            autoComplete="email"
          />
          <div id="emailHelp" className="form-text">
            We'll never share your email with anyone else.
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="exampleInputPassword1" className="form-label">
            Password
          </label>
          
          <input
            type="password"
            className="form-control"
            name="password"
            id="password"
            value={data.password}
            onChange={onchange}
            autoComplete="current-password"
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </form>
    </div>
  );
}
